var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicios3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feecb0;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.65,143.12h-28.64c-2.58,0-4.95-1.3-6.33-3.49l-19.01-29.93c-.81-1.28-.44-2.98,.85-3.8,1.28-.81,2.98-.43,3.8,.85l19.01,29.94c.36,.58,1.01,.93,1.68,.93h23.14v-9.8h-14.72c-2.58,0-4.95-1.3-6.33-3.48l-12.62-19.85c-.82-1.28-.44-2.98,.84-3.8,1.29-.82,2.98-.44,3.8,.84l12.62,19.85c.36,.58,1.01,.93,1.68,.93h20.22v20.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M180.5,162.41h-15.83c-4.14,0-7.52-3.37-7.52-7.52v-41.25c0-4.14,3.37-7.52,7.52-7.52h15.83v56.28Zm-15.83-50.78c-1.11,0-2.02,.9-2.02,2.02v41.25c0,1.11,.9,2.02,2.02,2.02h10.33v-45.28h-10.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.35,132.86l-13.61-38.65c-.5-1.43,.25-3,1.68-3.51,1.44-.5,3,.25,3.51,1.68l11.79,33.47,104.4-36.77-4.33-12.29c-.5-1.43,.25-3,1.68-3.51,1.43-.51,3,.25,3.51,1.68l6.15,17.47-114.78,40.43Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.75,131.38l-12.01-34.11,21.27-7.49,12.01,34.11-21.27,7.49Zm-5-30.75l8.36,23.73,10.9-3.84-8.36-23.73-10.9,3.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.58,110.93l-44.35-28.09L150.44,36.84l13.69,38.87L62.58,110.93Zm-31.78-26.64l32.48,20.57,93.83-32.53-10.04-28.49L30.8,84.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicios3);
export default __webpack_public_path__ + "static/media/servicios3.120129e20694de8e20399aebc5208c32.svg";
export { ForwardRef as ReactComponent };